import Icon from "@mdi/react";
import {
  mdiPrinter,
  mdiMinusCircle,
  mdiPlusCircle,
  mdiClipboardMultipleOutline,
} from "@mdi/js";
import "../../../assets/styles/admin/booking.scss";
import MainButton from "../../../components/button/mainButton";
import { useEffect, useState } from "react";
import FullCalendar, { formatDate, EventInput } from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import EmptyModel from "../../../components/modal/emptyModal";
import CheckboxText from "../../../components/textfield/checkbox";
import SelectField from "../../../components/select/selectField";

interface Props {
  data: any;
}

const WorkerTable: React.FC<Props> = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [boolean, setBoolean] = useState<boolean>();
  const [docTors, setDoctors] = useState<any>({ val: [] });
  const [selectInfo, setSelectInfo] = useState<any>([]);

  const [values, setValues] = useState<any>({ val: [] });
  let eventGuid = 0;

  const doctor = [
    { value: "นายดนุภัทร สมศรี1", name: "นายดนุภัทร สมศรี1" },
    { value: "นายดนุภัทร สมศรี2", name: "นายดนุภัทร สมศรี2" },
    { value: "นายดนุภัทร สมศรี3", name: "นายดนุภัทร สมศรี3" },
  ];

  const [state, setState] = useState<any>({
    data: [
      {
        title: "1",
        start: "2022-02-06",
        display: "background",
        color: "#5baea9",
        textColor: "#FFF",
      },
      {
        title: "1",
        start: "2022-02-08",
        display: "background",
        color: "#5baea9",
        textColor: "#FFF",
      },
    ],
    copied: false,
    currentEvents: [],
  });

  const handleDateSelect = (selectInfo: any) => {
    setSelectInfo(selectInfo);
    setIsOpen(true);
  };

  function createInputs() {
    return values.val.map((el: any, i: any) => (
      <div style={{ alignItems: "center", display: "flex" }} key={i}>
        <div className="col-10">
          <div
            className="row"
            style={{ padding: "20px 40px", justifyContent: "space-between" }}
          >
            <div key={i} className="">
              <SelectField
                title="THERAPIST"
                className="col-10"
                option={doctor}
                value={el[i]}
                onChange={handleChange.bind(el, i)}
              />
            </div>
          </div>
        </div>
        <div
          className="col-1"
          style={{ textAlign: "center", cursor: "pointer" }}
          onClick={removeClick.bind(i)}
        >
          <Icon path={mdiMinusCircle} size="25" color="#E76464" />
        </div>
      </div>
    ));
  }

  function handleChange(index: any, event: any) {
    let vals = [...values.val];
    vals[index] = event.target.value;
    setDoctors({ ...docTors, val: vals });
  }

  const addClick = () => {
    setValues({ val: [...values.val, ""] });
  };

  const removeClick = (event: any) => {
    let vals = [...values.val];
    let index = Number(event.target.name);
    vals.splice(index, 1);
    setValues({ val: vals });
  };

  const createData = (selectInfo: any) => {
    setIsOpen(false);
    let num = values.val.length;
    return onHandledata({
      title: num.toString(),
      start: selectInfo.startStr,
      display: "background",
      color: "#5baea9",
      textColor: "#FFF",
    });
  };

  function onHandledata(val: any) {
    // let data = state.data;
    // data.push(val);

    let calendarApi = selectInfo.view.calendar;

    calendarApi.unselect();

    console.log("calendarApi => ", calendarApi);
    calendarApi.addEvent({
      title: val.title,
      start: selectInfo.startStr,
      display: "background",
      color: "#5baea9",
      textColor: "#FFF",
      allDay: selectInfo.allDay,
    });

    console.log("listitem => ", val);
    // setState({ ...state, data });
  }

  function onClose() {
    setIsOpen(false);
  }

  function renderEventContent(eventInfo: any) {
    return (
      <>
        <div className="div-event-day">
          <div className="bg-event-font mg-10">ผู้ปฏิบัติงานทั้งหมด</div>
          <div className="bg-event-title mg-10">{eventInfo.event.title}</div>
          <div className="bg-event-font text-decora-line mg-10">
            กดดูทั้งหมด
          </div>
        </div>
      </>
    );
  }

  const handleEvents = (events: any) => {
    setState({
      currentEvents: events,
    });
  };

  function createEventId() {
    return String(eventGuid++);
  }

  useEffect(() => {
    setState({ ...state, data });
  }, []);

  return (
    <div style={{ padding: "0px 40px" }}>
      <EmptyModel show={isOpen} onClose={onClose} width="60%">
        <form>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "20px 40px",
            }}
          >
            <h4 style={{ padding: "5px 25px" }}>เพิ่มผู้ปฏิบัติงาน</h4>
            <div className="row">
              <div
                style={{
                  alignItems: "center",
                  display: "flex",
                  margin: " 0px 40px",
                }}
              >
                <div className="col-12">
                  <div className="row">
                    <div
                      style={{
                        color: "#5baea9",
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <b>สำหรับ</b>
                    </div>

                    <CheckboxText
                      className="col-2"
                      id="1"
                      title="วันนี้"
                      onChange={(e) => {
                        setBoolean(e.target.checked);
                      }}
                    />
                    <CheckboxText
                      className="col-3"
                      id="1"
                      title="สัปดาห์นี้"
                      onChange={(e) => {
                        setBoolean(e.target.checked);
                      }}
                    />
                    <CheckboxText
                      className="col-2"
                      id="1"
                      title="เดือนนี้"
                      onChange={(e) => {
                        setBoolean(e.target.checked);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              {createInputs()}
              <div
                style={{
                  alignItems: "center",
                  display: "flex",
                  cursor: "pointer",
                  margin: "0px 25px",
                }}
                onClick={addClick}
              >
                <div
                  className="col-1"
                  style={{ textAlign: "center", cursor: "pointer" }}
                >
                  <Icon path={mdiPlusCircle} size="25" color="#4D7E7F" />
                </div>
                <div className="col-11">
                  <div
                    className="row"
                    style={{
                      padding: "20px 10px",
                      justifyContent: "space-between",
                    }}
                  >
                    เพิ่มผู้ปฏิบัติงาน
                  </div>
                </div>
              </div>
              <div className="justify-center">
                <MainButton
                  className="mg-10"
                  background="#E76464"
                  title="ยกเลิก"
                  onClick={() => {
                    setIsOpen(false);
                  }}
                />
                <MainButton
                  className="mg-10"
                  title="บันทึกข้อมูล"
                  onClick={() => {
                    createData(selectInfo);
                  }}
                />
              </div>
            </div>
          </div>
        </form>
      </EmptyModel>
      <div className="create-page" style={{ padding: "0px 10px" }}>
        <div className="row">
          <div className="slect-booking">
            <div className="booking-datePicker">
              {/* <DatePicker size={`middle`} bordered={false} /> */}
            </div>
            <div className="booking-btnPrint">
              <MainButton title="Print" width="90px" className="mg-10">
                <Icon path={mdiPrinter} size="20" color="#FFFFFF" />
              </MainButton>
            </div>
          </div>
        </div>
        <div style={{ padding: "20px 10px" }}>
          {/* <FullCalendar
            plugins={[dayGridPlugin, interactionPlugin]}
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={true}
            select={handleDateSelect}
            eventContent={renderEventContent}
            eventsSet={handleEvents}
            initialEvents={state.data}
          /> */}
        </div>
      </div>
    </div>
  );
};
export default WorkerTable;
